import { Grid2, IconButton } from "@mui/material";
import toast, { ToastBar, Toaster } from "react-hot-toast";
import { logout } from "store/slices/userSlice";
import { useAppDispatch } from "store/store";
import { GKModalProps } from "utils/commonInterface";
import GKButton from "./GKButton";
import GKModal from "./GKModal";
import GKTypography from "./GKTypography";
import { CheckFilledIcon, CloseIcon, ErrorfilledIcon } from "./Icons";
import { Show } from "./Show";

export default function VersionModal(props: GKModalProps) {
  const dispatch = useAppDispatch();

  const { open, setOpen } = props;

  return (
    <GKModal
      modalTitle={"Version Control"}
      open={open}
      setOpen={setOpen}
      closeBtn={false}
      footer={
        <Grid2
          container
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <GKButton
            variant="outlined"
            color="error"
            onClick={() => dispatch(logout())}
          >
            Logout
          </GKButton>
        </Grid2>
      }
    >
      <GKTypography
        fontSize={18}
        fontWeight={500}
        color={"var(--primary-900)"}
        textAlign={"center"}
      >
        We have updated our systems for a better experience, please re-login
        into your account.
      </GKTypography>
    </GKModal>
  );
}

export function MainToaster() {
  return (
    <Toaster
      position="top-center"
      reverseOrder={false}
      gutter={8}
      toastOptions={{
        duration: 3000,
        style: {
          maxWidth: "unset",
          fontWeight: 500,
          fontSize: 12,
          borderRadius: 8,
          padding: "12px 16px 12px 12px",
          alignItems: "center",
          display: "inline-flex",
          gap: 8,
          border: "1px solid var(--gray-400)",
          background: "var(--neutral-900)",
          boxShadow: `0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 8px 12px 6px rgba(0, 0, 0, 0.15)`,
          color: "var(--white)",
        },
        success: {
          icon: (
            <CheckFilledIcon
              width={20}
              height={20}
              color={"var(--success-700)"}
            />
          ),
        },
        error: {
          icon: (
            <ErrorfilledIcon
              width={20}
              height={20}
              color={"var(--error-color)"}
            />
          ),
        },
      }}
    >
      {(t) => (
        <ToastBar toast={t} position="top-center">
          {({ icon, message }) => (
            <>
              {icon}
              {message}
              <Show.When isTrue={t.type !== "loading"}>
                <IconButton
                  style={{ padding: 4 }}
                  onClick={() => toast.dismiss(t.id)}
                >
                  <CloseIcon width={16} height={16} color="var(--grey-300)" />
                </IconButton>
              </Show.When>
            </>
          )}
        </ToastBar>
      )}
    </Toaster>
  );
}
